"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListHeader = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
var colors_1 = require("../../../theme/colors");
var button_1 = require("../../button");
var button_menu_1 = require("../../button-menu");
var flexbox_1 = require("../../flexbox");
var input_1 = require("../../input");
var padding_1 = require("../../padding");
var spacing_1 = require("../../spacing");
function isMultiple(actions) {
    return actions.actions !== undefined;
}
function ListHeader(props) {
    var overflowActions = props.overflowActions, searchOptions = props.searchOptions;
    var handler = searchOptions.handler, keyword = searchOptions.keyword, _a = searchOptions.placeholder, placeholder = _a === void 0 ? 'Filter by keyword' : _a;
    return (react_1.default.createElement(Wrapper, null,
        react_1.default.createElement(padding_1.Padding, { size: 12 },
            react_1.default.createElement(flexbox_1.Flexbox, { alignItems: "center", justifyContent: "space-between" },
                react_1.default.createElement(input_1.Input, { placeholder: placeholder, onChange: handler, value: keyword, type: "search", style: { flexGrow: 1 } }),
                overflowActions && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(spacing_1.Spacing, { width: 12 }),
                    isMultiple(overflowActions) ? (react_1.default.createElement(button_menu_1.ButtonMenu, { items: overflowActions.actions, variant: "primary" }, overflowActions.label)) : (react_1.default.createElement(button_1.Button, { size: "primary", type: "button", onClick: function () { return overflowActions.onClick(true); } }, overflowActions.label))))))));
}
exports.ListHeader = ListHeader;
var Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = (0, tslib_1.__makeTemplateObject)(["\n  border-bottom: 1px solid ", ";\n"], ["\n  border-bottom: 1px solid ", ";\n"])), colors_1.colors.steel[200]);
var templateObject_1;
//# sourceMappingURL=list-header.js.map